import Vue from 'vue'
import _ from 'lodash'

// STATE
export const state = Vue.observable({
  mandatoryComments: {}
})

// COMPUTED (ish)

export function hasEmptyComments() {
  return _.some(state.mandatoryComments, (comment) => !comment.value)
}

export const mandatoryComments = () => _.map(state.mandatoryComments, (comment) => comment)
